import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, expires) {
  let params = {}
  if (expires) {
    params.expires = expires
  }
  return Cookies.set(TokenKey, token, params)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
